import { MenuItem, Typography } from '@mui/material';
import { useContext } from 'react';
import { PopoverMenuContext } from './PopoverMenuContext';

const PopoverMenuItem = ({
  onClick: handleClick,
  icon: Icon,
  title,
  children,
  ...props
}) => {
  const { closeMenu } = useContext(PopoverMenuContext);

  return (
    <MenuItem
      {...props}
      onClick={() => {
        handleClick();
        closeMenu();
      }}
    >
      {Icon && <Icon sx={{ fontSize: 20 }} />}
      <Typography
        variant="body2"
        sx={{
          ...(Icon && { ml: 2 }),
        }}
      >
        {title}
      </Typography>
      {children}
    </MenuItem>
  );
};

export default PopoverMenuItem;
